import { useMsal } from '@azure/msal-react';
import { NavLink, Outlet } from 'react-router-dom';
import { useMe } from '../api/hooks';

export default function Layout() {
  const { instance } = useMsal();
  const { data: me } = useMe();

  const signOut = () => {
    instance.logoutRedirect().catch((e) => console.error(e));
  };

  return (
    <div className="page">
      <header className="topbar">
        <div className="brand-nav">
          <strong>CV Review</strong>
          <nav className="nav">
            <NavLink to="/" end className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
              Home
            </NavLink>
            <NavLink
              to="/jobs"
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Jobs
            </NavLink>
            <NavLink
              to="/candidates"
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Candidates
            </NavLink>
            {me?.roles.isAdmin && (
              <NavLink
                to="/admin/users"
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                Users
              </NavLink>
            )}
            {me?.roles.isAdmin && (
              <NavLink
                to="/admin/audit"
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                Audit
              </NavLink>
            )}
          </nav>
        </div>
        <div className="topbar-right">
          {me && <span className="muted small">{me.email}</span>}
          <button className="btn-ghost" onClick={signOut}>
            Sign out
          </button>
        </div>
      </header>

      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
